// Gallery.js

import React from 'react';

function Gallery({ title, shortTitle, thumbs, onImageClick }) {
    return (    
        <section className="left">
            <div className="header desktop">{title}</div>
            <div className="header tablet">{shortTitle}</div>

            <div className="gallery">
            {thumbs && (
                <div className="gallery-content">
                {thumbs.map((image, index) => (
                    <div key={index} className="gallery-item">
                    <img 
                        key={image.id}
                        src={image.thumbnail}
                        alt={image.alt}
                        onClick={() => onImageClick(image)}  
                    />                    
                    </div>
                ))}
                </div>
            )} 
            </div>
        </section>
    );
}

export default Gallery;